import Modal from "~/components/ui/Modal";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { UpgradeFunnel } from "~/components/upgrade-funnel";
import { DISABLE_PAYMENTS } from "~/helpers/plans";
import { useAccount } from "~/hooks/useAccount";
import { useModalTrigger } from "~/hooks/useModalTrigger";
import { SHOW_CONNECT_STORE_MODAL } from "~/helpers/customEvents";

export const ShowUpgradeModal = ({ open = false }: { open?: boolean }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { account } = useAccount();

  const location = useLocation();
  const [isOpen, setIsOpen] = useModalTrigger(SHOW_CONNECT_STORE_MODAL, open);

  const planId = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get("plan_id") || "";
  }, [location.search]);

  useEffect(() => {
    if (planId) setIsOpen(true);
  }, [planId]);

  useEffect(() => {
    if (account?.has_used_stripe_upgrade_funnel_coupon) {
      setIsOpen(false);
    }
  }, [account]);

  const redirectAndClose = () => {
    if (searchParams.has("plan_id")) {
      const plan_id = searchParams.get("plan_id");
      if (plan_id) {
        searchParams.delete("plan_id");
        setSearchParams(searchParams);
      }
    }
    setIsOpen(false);
  };

  return (
    <Modal
      id="upgrade-funnel"
      hide={redirectAndClose}
      isShowing={isOpen && !DISABLE_PAYMENTS}
      padding="0">
      <UpgradeFunnel planId={planId} close={redirectAndClose} />
    </Modal>
  );
};
